/* Wave Konfigurátor — zdieľaná logika.
   Model: zákazník vyberie VRCH + PODSTAVEC, krytka sa doplní automaticky,
   v 3D si vyberie IBA farbu krytky. */
(function () {
  var fmt = WAVE.fmt;
  var items = [WaveCore.newLamp()], activeIdx = 0, lastTotal = null, sharedRestore = false;
  var active = function () { return items[activeIdx]; };
  var $ = function (id) { return document.getElementById(id); };
  var lampsWord = function (n) { return n === 1 ? 'lampa' : (n >= 2 && n <= 4 ? 'lampy' : (WAVE.text("lámp"))); };

  // obnov konfiguráciu zo zdieľaného odkazu (?c=...)
  (function () {
    var m = location.search.match(/[?&]c=([^&]+)/);
    if (!m) return;
    var r = WaveCore.decodeConfig(m[1]);
    if (r && r.items.length) { items = r.items; activeIdx = r.activeIdx; sharedRestore = true; }
  })();

  var viewer = $('viewer');
  // Zaregistruj kroma3d:ready handshake EŠTE PRED nastavením src (mountViewer), nech ho nezmeškáme.
  if (sharedRestore) WaveCore.onViewerReady(viewer, function () { pushActive(); });
  var sendSize = WaveCore.mountViewer(viewer, false);  // forceDesktop vždy — ako KUMO (správne menu Konfigurovať)
  WaveCore.mountFullscreen({ btn: $('fs-btn'), preview: $('preview'), label: $('fs-label'), icon: $('fs-icon'), onChange: sendSize });
  if ($('fs-mobile')) $('fs-mobile').onclick = function () { var b = $('fs-btn'); if (b) b.click(); };
  WaveCore.listenSelection(active, render);

  // prepínač 3D / Foto (teplá / studená)
  var photoEl = $('photo'), photoFb = $('photo-fallback');
  if (photoEl) {
    photoEl.onerror = function () { photoEl.hidden = true; if (photoFb) photoFb.hidden = false; };
    photoEl.onload = function () { if (photoFb) photoFb.hidden = true; };
  }
  function setView(v) {
    ['3d', 'warm', 'cool'].forEach(function (k) {
      var b = $('vt-' + k); if (!b) return;
      var on = k === v; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (!photoEl) return;
    if (v === '3d') { photoEl.hidden = true; if (photoFb) photoFb.hidden = true; }
    else { if (photoFb) photoFb.hidden = true; photoEl.src = v === 'warm' ? WAVE.photos.warm : WAVE.photos.cool; photoEl.hidden = false; }
  }
  ['3d', 'warm', 'cool'].forEach(function (k) { var b = $('vt-' + k); if (b) b.onclick = function () { setView(k); }; });

  // zdieľať / uložiť konfiguráciu
  if ($('share-btn')) $('share-btn').onclick = function () {
    var url = location.origin + location.pathname + '?c=' + WaveCore.encodeConfig(items, activeIdx);
    var btn = this, orig = btn.textContent;
    function done() { btn.classList.add('ok'); btn.textContent = (WAVE.text("Odkaz skopírovaný")); setTimeout(function () { btn.textContent = orig; btn.classList.remove('ok'); }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt((WAVE.text("Skopíruj odkaz na svoju lampu:")), url); });
    else window.prompt((WAVE.text("Skopíruj odkaz na svoju lampu:")), url);
  };

  $('exp-price').textContent = fmt(WAVE.express);
  $('bulb-was').textContent = fmt(WAVE.bulb.was);
  $('bulb-add').textContent = fmt(WAVE.bulb.add);
  // Klik na CELY riadok (label/cena/slider) prepne prepinac, nie len samotny slider.
  // Pod-volby (objimka/farba svetla) su mimo .toggle-row, takze sa nezopnu.
  (function () {
    var bRow = ($('bulb-swt').closest && $('bulb-swt').closest('.toggle-row')) || $('bulb-swt');
    bRow.style.cursor = 'pointer';
    bRow.onclick = function () { active().bulb.on = !active().bulb.on; render(); };
    var eRow = ($('exp-swt').closest && $('exp-swt').closest('.toggle-row')) || $('exp-swt');
    eRow.style.cursor = 'pointer';
    eRow.onclick = function () { active().express = !active().express; render(); };
  })();
  if ($('top-matte')) $('top-matte').onclick = function () { active().topMatte = !active().topMatte; render(); pushActive(); };
  if ($('base-matte')) $('base-matte').onclick = function () { active().baseMatte = !active().baseMatte; render(); pushActive(); };

  function pushActive() {
    try {
      var l = active();
      if (l.kromaSel && l.kromaSel.length) {
        // presné obnovenie 3D výberu (tvar + variant + farby) cez oficiálne kroma3d API
        var payload = { type: 'kroma3d:setselection', selections: l.kromaSel };
        if (/[?&]kromadebug=1/.test(location.search)) { try { console.log('[kroma3d->viewer] setselection', JSON.stringify(payload)); } catch (e) {} }
        viewer.contentWindow.postMessage(payload, 'https://kroma3d.app');
      } else {
        // fallback (lampa nebola konfigurovaná v 3D): aspon farba krytky + tvar
        viewer.contentWindow.postMessage({ type: 'wave:setColor', cap: l.cap.colorHex, top: l.top, base: l.base }, 'https://kroma3d.app');
      }
    } catch (e) {}
  }
  // Obnova zo zdieľaného odkazu (?c=) sa rieši cez WaveCore.onViewerReady vyššie
  // (čaká na kroma3d:ready, potom pošle setselection); žiadne setTimeout odhady.

  function renderTabs() {
    var el = $('tabs'); el.innerHTML = '';
    items.forEach(function (l, i) {
      var t = document.createElement('button'); t.className = 'tab' + (i === activeIdx ? ' active' : '');
      t.innerHTML = '<span class="dot" style="background:' + l.cap.colorHex + '"></span>Lampa ' + (i + 1);
      t.onclick = function () { activeIdx = i; render(); pushActive(); };
      if (items.length > 1) {
        var rm = document.createElement('span'); rm.className = 'rm'; rm.innerHTML = '&times;';
        rm.onclick = function (e) { e.stopPropagation(); items.splice(i, 1); if (activeIdx >= items.length) activeIdx = items.length - 1; render(); pushActive(); };
        t.appendChild(rm);
      }
      el.appendChild(t);
    });
    if (items.length < WAVE.maxLamps) {
      var a = document.createElement('button'); a.className = 'tab add';
      var tc = WaveCore.lampCount(items);
      var hint = tc === 1 ? ' · −7 %' : (tc === 2 ? ' · −14 %' : '');
      a.innerHTML = (WAVE.text("+ Pridať lampu")) + (hint ? '<span class="save">' + hint + '</span>' : '');
      a.onclick = function () { items.push(WaveCore.newLamp()); activeIdx = items.length - 1; render(); pushActive(); };
      el.appendChild(a);
    }
  }

  function renderTops() {
    var l = active(); var el = $('tops'); if (!el) return; el.innerHTML = '';
    WAVE.tops.forEach(function (t) {
      var b = document.createElement('button'); b.className = 'obtn opt' + (l.top === t.id ? ' active' : '');
      b.innerHTML = '<span class="opt-name">' + t.name + '</span><span class="opt-pr">' + fmt(WaveCore.priceOfItem(t)) + '</span>';
      b.onclick = function () { l.top = t.id; render(); pushActive(); };
      el.appendChild(b);
    });
    var tm = $('top-matte'); if (tm) tm.classList.toggle('on', l.topMatte);
  }

  function renderBases() {
    var l = active(); var el = $('bases'); if (!el) return; el.innerHTML = '';
    WAVE.bases.forEach(function (bs) {
      var cap = WAVE.caps[bs.cap];
      var price = WaveCore.priceOfItem(bs) + (cap ? WaveCore.priceOfItem(cap) : 0);
      var b = document.createElement('button'); b.className = 'obtn opt' + (l.base === bs.id ? ' active' : '');
      b.innerHTML = '<span class="opt-name">' + WAVE.text(bs.name) + (bs.light ? ("<span class=\"badge-bundle\">" + WAVE.text("so svetlom") + "</span>") : '') + '</span><span class="opt-pr">' + fmt(price) + ("<small>" + WAVE.text(" · vr. krytky") + "</small>" + "</span>");
      b.onclick = function () { l.base = bs.id; render(); pushActive(); };
      el.appendChild(b);
    });
    var bm = $('base-matte'); if (bm) bm.classList.toggle('on', l.baseMatte);
  }

  function renderSum() {
    var l = active();
    var top = WaveCore.topById(l.top), base = WaveCore.baseById(l.base), cap = WaveCore.capOfBase(l.base);
    var tc = l.topColor || { hex: '#FFFFFF', name: 'Biela' };
    var bc = l.baseColor || { hex: '#FFFFFF', name: 'Biela' };
    var swCss = 'width:24px;height:24px;border-radius:50%;border:1px solid rgba(0,0,0,.18);box-shadow:0 0 0 3px rgba(0,0,0,.04);flex:0 0 auto';
    function row(lab, name, color) {
      return '<div class="sum-row"><span class="sw" style="background:' + color.hex + ';' + swCss + '"></span>' +
        '<span class="lab">' + lab + '</span>' +
        '<div class="val">' + WAVE.text(name) + '<small>' + WAVE.text(color.name) + '</small></div></div>';
    }
    var rows = '';
    rows += row('Vrch', WAVE.text(top.name), tc);
    rows += row((WAVE.text("Podstavec")), WAVE.text(base.name) + (cap ? ' + ' + WAVE.text(cap.name) : ''), bc);
    rows += row('Krytka', cap ? WAVE.text(cap.name) : 'Krytka', { hex: l.cap.colorHex, name: l.cap.colorName });
    $('sum').innerHTML = rows;
  }

  function renderSpecs() {
    var el = $('specs'); if (!el) return;
    var l = active();
    el.innerHTML =
      ("<div class=\"spec\">" + "<span class=\"sk\">" + WAVE.text("Výška") + "</span>" + "<span class=\"sv\">") + WaveCore.lampHeight(l) + ' cm</span></div>' +
      ("<div class=\"spec\">" + "<span class=\"sk\">" + WAVE.text("Hmotnosť") + "</span>" + "<span class=\"sv\">" + WAVE.text("≈ ")) + WaveCore.lampWeight(l) + ' g</span></div>' +
      ("<div class=\"spec\">" + "<span class=\"sk\">" + WAVE.text("Výroba") + "</span>" + "<span class=\"sv\">" + WAVE.text("ručne v SK") + "</span>" + "</div>");
  }

  function renderDelivery() {
    var l = active();
    var info = WaveCore.deliveryInfo(l.express);
    var d = $('deliv');
    if (d) d.innerHTML = ("<span class=\"dv-ic\" aria-hidden=\"true\">" + "</span>" + "<span>" + WAVE.text("Objednaj teraz a doručíme ") + "<b>") + info.label + '</b>' + (l.express ? (WAVE.text(" (expresná výroba)")) : '') + '</span>';
    var t = $('trust-deliv'); if (t) t.textContent = (WAVE.text("Doručíme ")) + info.label;
  }

  function renderPower() {
    var l = active(); var el = $('power'); if (!el) return;
    var hasLight = WaveCore.baseHasLight(l);
    var opts = WAVE.power.filter(function (p) {
      if (p.forLight) return hasLight;       // USB LED modul — len LED podstavce
      if (p.forPassive) return !hasLight;    // objímky — len pasívne podstavce
      return true;                            // bez napájania — vždy
    });
    if (!opts.some(function (p) { return p.id === l.power; })) l.power = 'none';
    el.innerHTML = '';
    opts.forEach(function (p) {
      var b = document.createElement('button'); b.className = 'obtn pw' + (l.power === p.id ? ' active' : '');
      var pr = p.add ? ('<span class="opr">' + (p.was ? '<s>' + fmt(p.was) + '</s>' : '') + '+' + fmt(p.add) + '</span>') : ("<span class=\"opr\" style=\"color:#16a34a\">" + WAVE.text("v cene") + "</span>");
      var ic = p.icon ? '<span class="pw-ic">' + p.icon + '</span>' : '';
      b.innerHTML = '<span class="pw-top"><span class="pw-name">' + ic + WAVE.text(p.label) + (p.bundle ? '<span class="badge-bundle">s lampou</span>' : '') + '</span>' + pr + '</span><small>' + WAVE.text(p.sub) + '</small>';
      b.onclick = function () { l.power = p.id; render(); };
      el.appendChild(b);
    });
    var isSocket = l.power === 'socket', isDimmer = l.power === 'dimmer';
    $('socket-sub').style.display = isSocket ? '' : 'none';
    $('dimmer-warn').style.display = isDimmer ? '' : 'none';
    var st = $('socket-types'); st.innerHTML = '';
    WAVE.socketTypes.forEach(function (s) {
      var b = document.createElement('button'); b.className = 'obtn inline' + (l.socketType === s ? ' active' : ''); b.textContent = s;
      b.onclick = function () { l.socketType = s; render(); };
      st.appendChild(b);
    });
  }

  function renderBulb() {
    var l = active();
    $('bulb-swt').classList.toggle('on', l.bulb.on);
    $('bulb-swt').setAttribute('aria-pressed', l.bulb.on ? 'true' : 'false');
    $('bulb-sub').style.display = l.bulb.on ? '' : 'none';
    var bs = $('bulb-sockets'); bs.innerHTML = '';
    WAVE.bulb.sockets.forEach(function (s) {
      var b = document.createElement('button'); b.className = 'obtn inline' + (l.bulb.socket === s ? ' active' : ''); b.textContent = s;
      b.onclick = function () { l.bulb.socket = s; render(); };
      bs.appendChild(b);
    });
    var bt = $('bulb-temps'); bt.innerHTML = '';
    WAVE.bulb.temps.forEach(function (t) {
      var b = document.createElement('button'); b.className = 'obtn inline' + (l.bulb.temp === t.id ? ' active' : ''); b.textContent = WAVE.text(t.label);
      b.onclick = function () { l.bulb.temp = t.id; render(); };
      bt.appendChild(b);
    });
  }

  function renderExpress() {
    var l = active();
    $('express').classList.toggle('on', l.express);
    $('exp-swt').classList.toggle('on', l.express);
    $('exp-swt').setAttribute('aria-pressed', l.express ? 'true' : 'false');
  }

  function renderPrice() {
    var l = active(); var el = $('brk');
    var top = WaveCore.topById(l.top), base = WaveCore.baseById(l.base);
    function row(lab, v) { return '<div class="row"><span>' + lab + '</span><span>' + v + '</span></div>'; }
    var h = row((WAVE.text("Vrch \u2014 ")) + WAVE.text(top.name), fmt(WaveCore.topPrice(l)));
    h += row((WAVE.text("Podstavec \u2014 ")) + WAVE.text(base.name) + ' (s krytkou)', fmt(WaveCore.baseUnitPrice(l)));
    if (l.topMatte) h += row((WAVE.text("Matný vrch")), '+' + fmt(WAVE.matteSurcharge));
    if (l.baseMatte) h += row((WAVE.text("Matný podstavec")), '+' + fmt(WAVE.matteSurcharge));
    var p = WAVE.power.find(function (x) { return x.id === l.power; }); if (p && p.add) h += row(WAVE.text(p.label), '+' + fmt(p.add));
    if (l.bulb.on) h += row((WAVE.text("LED žiarovka (")) + l.bulb.socket + ', ' + (l.bulb.temp === 'warm' ? (WAVE.text("teplá 2700K")) : (WAVE.text("studená 6500K"))) + ', 2,2 W)', '+' + fmt(WAVE.bulb.add));
    if (l.express) h += row((WAVE.text("Expresná výroba")), '+' + fmt(WAVE.express));
    if (l.qty > 1) h += row('Cena za kus', fmt(WaveCore.calcLamp(l)));
    h += row((WAVE.text("Počet kusov")), l.qty + ' ×');
    var lampTotal = WaveCore.calcLamp(l) * l.qty;
    var vatAmount = lampTotal * WAVE.vat / (100 + WAVE.vat);
    h += '<div class="row vat-line"><span>z toho DPH ' + WAVE.vat + ' %</span><span>' + fmt(vatAmount) + '</span></div>';
    h += '<div class="row tot"><span>Lampa ' + (activeIdx + 1) + '</span><span>' + fmt(lampTotal) + ("<span class=\"vat\">" + WAVE.text("vrátane DPH") + "</span>" + "</span>" + "</div>");
    el.innerHTML = h;

    var totEl = el.querySelector('.row.tot span:last-child');
    if (totEl && lastTotal !== null && Math.abs(lastTotal - lampTotal) > 0.001) {
      totEl.classList.remove('pulse'); void totEl.offsetWidth; totEl.classList.add('pulse');
    }
    lastTotal = lampTotal;
    if ($('price-top')) $('price-top').textContent = fmt(lampTotal);

    var g = $('grand');
    var totalCount = WaveCore.lampCount(items);
    var rate = WaveCore.bundleRate(items);
    var sub = WaveCore.grandSubtotal(items);
    g.style.display = 'block';
    if (totalCount >= 2) {
      var disc = sub * rate;
      var gh = ("<div class=\"brow\">" + "<span>" + WAVE.text("Medzisúčet (")) + totalCount + ' ' + lampsWord(totalCount) + ')</span><span>' + fmt(sub) + '</span></div>';
      gh += ("<div class=\"disc-band\">" + "<span class=\"dl\">" + WAVE.text("Bundle zľava za ")) + totalCount + ' ' + lampsWord(totalCount) + '<b>−' + Math.round(rate * 100) + ' %</b></span><span class="dv">−' + fmt(disc) + '</span></div>';
      gh += ("<div class=\"brow fin\">" + "<span class=\"l\">" + WAVE.text("Spolu s DPH") + "</span>" + "<span class=\"v\">") + fmt(sub - disc) + '</span></div>';
      if (totalCount === 2) gh += ("<div class=\"promo\">" + "<span>" + WAVE.text("Pridaj ešte ") + "<b>" + WAVE.text("1 lampu") + "</b>" + WAVE.text(" a zľava stúpne na ") + "<b>" + WAVE.text("−14 %") + "</b>" + WAVE.text(".") + "</span>" + "</div>");
      g.innerHTML = gh;
    } else {
      g.innerHTML = ("<div class=\"promo\">" + "<span>" + WAVE.text("Kúp ") + "<b>" + WAVE.text("2 lampy = −7 %") + "</b>" + WAVE.text(", alebo ") + "<b>" + WAVE.text("3+ lampy = −14 %") + "</b>" + WAVE.text(" na celú objednávku.") + "</span>" + "</div>");
    }
    $('qn').textContent = l.qty;
  }

  // Bulletproof fill animation: a requestAnimationFrame tween that writes
  // transform:scaleX every frame. Independent of CSS transitions (which
  // prefers-reduced-motion silently kills) and of WAAPI transform
  // interpolation (flaky on some WebKit builds) — it cannot snap while the
  // tab is visible. Reads the previous scale from dataset.scale so it always
  // tweens from the current position, even after a re-render.
  function setBundleFill(fill, to) {
    var from = parseFloat(fill.dataset.scale);
    if (isNaN(from)) from = 0;
    fill.dataset.scale = String(to);
    if (fill._raf) { cancelAnimationFrame(fill._raf); fill._raf = 0; }
    if (from === to) { fill.style.transform = 'scaleX(' + to + ')'; return; }
    var dur = 900, t0 = 0;
    var ease = function (p) { return 1 - Math.pow(1 - p, 3); }; // easeOutCubic
    var frame = function (ts) {
      if (!t0) t0 = ts;
      var p = (ts - t0) / dur; if (p > 1) p = 1;
      fill.style.transform = 'scaleX(' + (from + (to - from) * ease(p)) + ')';
      fill._raf = p < 1 ? requestAnimationFrame(frame) : 0;
    };
    fill._raf = requestAnimationFrame(frame);
  }

  function renderBundleBar() {
    var el = $('bundle-bar'); if (!el) return;
    var count = WaveCore.lampCount(items);
    var sub = WaveCore.grandSubtotal(items);
    var avg = sub / Math.max(count, 1);
    var curIdx = count >= 3 ? 2 : count === 2 ? 1 : 0;
    var pct = [0, 50, 100][curIdx];
    var msg;
    if (count >= 3) {
      msg = (WAVE.text("Odomkol si ") + "<b>" + WAVE.text("maximálnu zľavu −14 %") + "</b>" + WAVE.text(". Ušetril si ") + "<b>") + fmt(sub * 0.14) + '</b>.';
    } else if (count === 2) {
      var add2 = (sub + avg) * 0.14 - sub * 0.07;
      msg = ("<b>" + WAVE.text("Skoro tam!") + "</b>" + WAVE.text(" Pridaj 3. lampu a zľava stúpne na ") + "<b>" + WAVE.text("−14 %") + "</b>" + WAVE.text(" \u2014 ušetríš ≈ ") + "<b>") + fmt(add2) + ("</b>" + WAVE.text(" navyše."));
    } else {
      var add1 = (sub * 2) * 0.07;
      msg = (WAVE.text("Pridaj ") + "<b>" + WAVE.text("2. lampu") + "</b>" + WAVE.text(" a získaš ") + "<b>" + WAVE.text("−7 %") + "</b>" + WAVE.text(" na celú objednávku \u2014 ušetríš ≈ ") + "<b>") + fmt(add1) + '</b>.';
    }

    if (!el.dataset.built) {
      var stops = [{ p: 0, lab: '1 ks' }, { p: 50, lab: '2 ks · −7 %' }, { p: 100, lab: '3 ks · −14 %' }];
      var sh = stops.map(function (s, i) {
        return '<span class="bb-stop s' + i + '" style="left:' + s.p + '%"><span class="cap">' + s.lab + '</span></span>';
      }).join('');
      el.innerHTML =
        '<div class="bb-msg"><span class="bb-txt"></span></div>' +
        '<div class="bb-track"><div class="bb-fill"></div>' + sh + '</div>';
      el.dataset.built = '1';
    }
    setBundleFill(el.querySelector('.bb-fill'), pct / 100);

    el.querySelector('.bb-txt').innerHTML = msg;
    var stopEls = el.querySelectorAll('.bb-stop');
    for (var i = 0; i < stopEls.length; i++) {
      stopEls[i].classList.toggle('done', count >= (i + 1));
      stopEls[i].classList.toggle('cur', i === curIdx);
    }
  }

  function render() { renderTabs(); renderBundleBar(); renderTops(); renderBases(); renderSum(); renderSpecs(); renderDelivery(); renderPower(); renderBulb(); renderExpress(); renderPrice(); }

  $('q-').onclick = function () { var l = active(); if (l.qty > 1) { l.qty--; render(); } };
  $('q+').onclick = function () { active().qty++; render(); };
  $('cta').onclick = function () {
    var S = window.WAVE_SHOPIFY || {};
    var variants = S.variants || {}, addons = S.addons || {};
    var cartItems = [], missing = false;
    items.forEach(function (l, idx) {
      var v = variants['WAVE-' + l.top + '-' + l.base];
      if (!v) { missing = true; return; }
      var top = WaveCore.topById(l.top), base = WaveCore.baseById(l.base);
      var qty = l.qty || 1;
      var lampLabel = 'Lampa ' + (idx + 1) + ' (' + top.name + ' + ' + base.name + ')';
      // hlavná položka = telo lampy (tvar + podstavec + krytka). Tvar je už vo variante,
      // do vlastností doplníme FARBY (vrch/podstavec/krytka) — formát "Názov (#hex)" ako KUMO.
      var tcol = l.topColor || { hex: '#FFFFFF', name: 'Biela' };
      var bcol = l.baseColor || { hex: '#FFFFFF', name: 'Biela' };
      cartItems.push({ id: v.id, quantity: qty, properties: {
        'Farba vrchu': tcol.name,
        'Farba podstavca': bcol.name,
        'Farba krytky': l.cap.colorName
      } });
      // doplnky = samostatné položky v košíku (KUMO štýl), množstvo škáluje s počtom kusov
      function addAddon(sku, extraProps) {
        var a = addons[sku]; if (!a) { missing = true; return; }
        var p = { 'Pre': lampLabel };
        if (extraProps) { for (var k in extraProps) p[k] = extraProps[k]; }
        cartItems.push({ id: a.id, quantity: qty, properties: p });
      }
      if (l.topMatte) addAddon('WAVE-ADDON-matte', { 'Povrch': 'Vrch (matný)' });
      if (l.baseMatte) addAddon('WAVE-ADDON-matte', { 'Povrch': 'Podstavec (matný)' });
      if (l.power === 'ledpuck') addAddon('WAVE-ADDON-ledpuck');
      else if (l.power === 'socket') addAddon('WAVE-ADDON-socket', { 'Objímka': l.socketType });
      else if (l.power === 'dimmer') addAddon('WAVE-ADDON-dimmer');
      if (l.bulb && l.bulb.on) addAddon('WAVE-ADDON-bulb', { 'Objímka': l.bulb.socket, 'Farba svetla': (l.bulb.temp === 'warm' ? 'teplá 2700K' : 'studená 6500K') });
      if (l.express) addAddon('WAVE-ADDON-express');
    });
    if (missing || !cartItems.length) { alert((WAVE.text("Niektorý variant sa nepodarilo nájsť. Skús prosím znova."))); return; }
    var btn = this, orig = btn.textContent;
    btn.disabled = true; btn.textContent = (WAVE.text("Pridávam do košíka..."));
    fetch((S.addUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cartItems, sections: ['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (res) { window.printhiaConfirmCartAddition(res.sections); btn.disabled = false; btn.textContent = orig; })
      .catch(function () { btn.disabled = false; btn.textContent = orig; alert((WAVE.text("Nepodarilo sa pridať do košíka. Skús prosím znova."))); });
  };

  // Reset CTA pri navrate na stranku (aj z bfcache po stlaceni Spat v prehliadaci) —
  // inak by tlacidlo ostalo zamknute na "Pridavam do kosika...". Skript sa pri bfcache
  // znova nespusti, ale pageshow event ano.
  (function () {
    var cta = $('cta'); if (!cta) return;
    var ctaLabel = cta.textContent;
    window.addEventListener('pageshow', function () { cta.disabled = false; cta.textContent = ctaLabel; });
  })();

  // FAQ akordeon — otvor len jednu otazku naraz (ako KUMO)
  document.querySelectorAll('.faq details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) document.querySelectorAll('.faq details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  render();
})();
